export interface CoordinateSettings {
  order: CoordinateOrder;
}

export type CoordinateOrder = 'NEZ' | 'ENZ';

export const CoordinateOrderOptions: Record<CoordinateOrder, string> = {
  NEZ: 'shared.ui.coordinateSettings.nezOptions',
  ENZ: 'shared.ui.coordinateSettings.enzOptions',
};
